// Shared by the editor and public menu: managed groups first, unassigned last.
export const groupMenuItems = (items, subcategories = []) => {
  const groups = subcategories.map(s => ({ id: s.id, label: s.name, items: [] }));
  const unassigned = { id: null, label: "", items: [] };
  const byId = new Map(groups.map(g => [g.id, g]));
  for (const item of items) (byId.get(item.subcategory_id) || unassigned).items.push(item);
  return [...groups, unassigned].filter(g => g.items.length).map(g => ({
    ...g,
    items: [...g.items].sort((a, b) => (a.sort_order - b.sort_order) || String(a.created_at).localeCompare(String(b.created_at)) || a.id.localeCompare(b.id)),
  }));
};
